module.exports = __webpack_public_path__ + "img/title-3-a4fbf7.png";